var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as pc from "playcanvas";
function isEntityOrDescendantOf(e, root) {
    var cur = e;
    while (cur) {
        if (cur === root)
            return true;
        cur = cur.parent;
    }
    return false;
}
function sampleFootprintEllipseRingsLocal(rx, rz, rings, pointsPerRing) {
    var pts = [];
    var rxx = Math.max(0, rx);
    var rzz = Math.max(0, rz);
    pts.push(new pc.Vec3(0, 0, 0)); // center
    for (var r = 1; r <= rings; r++) {
        var t = r / rings;
        var ringRx = rxx * t;
        var ringRz = rzz * t;
        for (var i = 0; i < pointsPerRing; i++) {
            var a = (i / pointsPerRing) * Math.PI * 2;
            pts.push(new pc.Vec3(Math.cos(a) * ringRx, 0, Math.sin(a) * ringRz));
        }
    }
    return pts;
}
function getWorldScale(entity) {
    var wt = entity.getWorldTransform();
    var d = wt.data;
    var sx = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    var sy = Math.sqrt(d[4] * d[4] + d[5] * d[5] + d[6] * d[6]);
    var sz = Math.sqrt(d[8] * d[8] + d[9] * d[9] + d[10] * d[10]);
    return new pc.Vec3(sx, sy, sz);
}
export function isCupAboveSolidSurface(params) {
    var e_1, _a;
    var _b;
    var app = params.app, cupVisualEntity = params.cupVisualEntity, cupWidth = params.cupWidth, cupDepth = params.cupDepth, maxDrop = params.maxDrop, objectEntityName = params.objectEntityName, _c = params.rings, rings = _c === void 0 ? 8 : _c, _d = params.pointsPerRing, pointsPerRing = _d === void 0 ? 32 : _d;
    var objectRoot = app.root.findByName(objectEntityName);
    if (!objectRoot)
        return { ok: false, reason: "OBJECT_ENTITY_NOT_FOUND" };
    var worldScale = getWorldScale(cupVisualEntity);
    var edgeMargin = cupWidth * 0.02;
    var rx = (cupWidth * 0.5 + edgeMargin) / worldScale.x;
    var rz = (cupDepth * 0.5 + edgeMargin) / worldScale.z;
    var localPts = sampleFootprintEllipseRingsLocal(rx, rz, rings, pointsPerRing);
    var maxX = 0;
    var wt = cupVisualEntity.getWorldTransform();
    var from = new pc.Vec3();
    var to = new pc.Vec3();
    var worldPt = new pc.Vec3();
    var center = new pc.Vec3();
    wt.transformPoint(new pc.Vec3(0, 0, 0), center);
    try {
        for (var localPts_1 = __values(localPts), localPts_1_1 = localPts_1.next(); !localPts_1_1.done; localPts_1_1 = localPts_1.next()) {
            var lp = localPts_1_1.value;
            if (maxX < lp.x) {
                maxX = lp.x;
            }
            wt.transformPoint(lp, worldPt);
            from.set(worldPt.x, worldPt.y + 5, worldPt.z);
            to.set(worldPt.x, worldPt.y - maxDrop, worldPt.z);
            var hits = (_b = app.systems.rigidbody) === null || _b === void 0 ? void 0 : _b.raycastAll(from, to);
            if (!hits || hits.length === 0) {
                return { ok: false, reason: "NO_HITS_ALONG_RAY" };
            }
            var objectHits = hits.filter(function (hit) { return hit.entity && isEntityOrDescendantOf(hit.entity, objectRoot); });
            if (objectHits.length === 0) {
                return { ok: false, reason: "OBJECT_NOT_UNDER_FOOTPRINT" };
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (localPts_1_1 && !localPts_1_1.done && (_a = localPts_1.return)) _a.call(localPts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { ok: true };
}
